
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { Toaster } from 'react-hot-toast';
// import ProtectedRoute from './components/ProtectedRoute';
// import PublicRoute from './components/PublicRoute';
import HomePage from './pages/HomePage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import CategoryPage from './pages/CategoryPage';
import AboutUsPage from './pages/AboutUsPage';
import GotraKuldevi from './component/GotraKuldevi';
import KuldeviProfile from './component/KuldeviProfile';
import BloggerDetailsPage from './pages/BloggerDetailsPage';
import BloggerPage from './pages/BloggerPage';
import PicArtPage from './pages/PicArtPage';
import MatrimonialRegistrationPage from './pages/MatrimonialRegistrationPage';
import FlipbookLayout from './component/FlipBookLayout';
       

function App() {
  return (
   <Router>
      {/* <Toaster position="top-right" /> */}

      <Routes>
        {/* Admin Layout and Dashboard */}
        {/* <Route element={<ProtectedRoute />}> */}
          {/* <Route path="/admin-Dashboard" element={<Dashboard />} /> */}
          {/* <Route path="/exercise" element={<Exercise />} /> */}

          {/* <Route path="/admin-comany-create" element={<CompanyRegistration />} /> */}

        {/* </Route> */}

        {/* Public Customer Routes */}
        <Route
          path="/*"
          element={
            <>
              {/* <CustomerHeader /> */}
              <Routes>
                {/* <Route path="/" element={<HomePage />} /> */}
                <Route path="/" element={<FlipbookLayout />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/Matrimonial-register" element={<MatrimonialRegistrationPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/category" element={<CategoryPage />} />
                <Route path="/aboutus" element={<AboutUsPage />} />
                <Route path="/category/:blogSlug" element={<BloggerPage />} />
                {/* <Route path="/category/:blogSlug" element={<PicArtPage />} /> */}
                {/* <Route path="/kuldevi" element={<KuldeviProfile />} /> */}

                {/* <Route path="/login" element={<PublicRoute />}> */}
                  {/* <Route index element={<Login />} /> */}
                {/* </Route> */}
                {/* <Route path="*" element={<PageNotFound />} /> */}
              </Routes>
              
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
